import { useCallback, useSyncExternalStore } from "react";

function supported(): boolean {
  return typeof window.matchMedia === "function";
}

/**
 * Whether a media query holds, following the window as it changes — for the
 * few places where the *markup* differs by width, not only the CSS (the fact
 * sheet becomes a `<details>` at 600 px, UX ruling 5). Without `matchMedia`
 * (jsdom) the answer is „wide" — the same fallback `prefersReducedMotion`
 * (`lib/motion.ts`) uses: no answer is the ordinary case.
 */
export function useNarrow(query = "(width <= 600px)"): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (!supported()) return () => undefined;
      const media = window.matchMedia(query);
      media.addEventListener("change", onChange);
      return () => media.removeEventListener("change", onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => supported() && window.matchMedia(query).matches,
    () => false,
  );
}
